module.exports = __webpack_public_path__ + "img/FI27603573.cbedec5f.png";